import React from "react";
import { Tabs } from "@mui/material";
import { useMessageSource } from "react-message-source";
import ProductTab from "./tab";
import { Product } from "../../../../context/product-context/product";

const classNameBase = "scd-product-selection-tabs";
export default function ProductTabs({
  selectedProduct,
  onProductChange,
}: {
  selectedProduct: Product;
  onProductChange: (event: React.SyntheticEvent, value: Product) => void;
}): React.JSX.Element {
  const { getMessage } = useMessageSource();
  const visibleTabs = selectedProduct?.family.products.length > 1;

  const tabs = () => (
    <div className={classNameBase}>
      <Tabs
        value={selectedProduct}
        scrollButtons={false}
        variant="fullWidth"
        onChange={onProductChange}
        classes={{
          root: `${classNameBase}-root`,
          flexContainer: `${classNameBase}-flex-container`,
          centered: `${classNameBase}-centered`,
          fixed: `${classNameBase}-fixed`,
          indicator: `${classNameBase}-indicator`,
        }}
      >
        {selectedProduct?.family.products.map((product: Product) => {
          return (
            <ProductTab
              key={product.productRef}
              title={getMessage(`${product.translationKey}.title`)}
              value={product}
              selectedProduct={selectedProduct?.productRef}
            />
          );
        })}
      </Tabs>
    </div>
  );

  return visibleTabs ? tabs() : null;
}
